import * as React from 'react';
import { NoSsr } from '@cian/react-utils';

import { Counters, ICounter } from './Counters';
import { Avatar } from './Avatar';
import { DescriptionRow } from './DescriptionRow';
import { IAgentCard, IAgentCardParticipation } from '../../../types/agentCard';
import { Name } from './Name';
import { Rating } from './Rating';
import { Section } from '../../common/section';

import * as styles from './AboutRealtorDesktop.css';

interface IAboutBlock {
  label: string;
  text: string;
  action?(): void;
}
export interface IAboutRealtorDesktopProps {
  about: IAboutBlock[];
  avatarUrl: IAgentCard['avatarUrl'];
  counters: ICounter[];
  isAvatarRound: boolean;
  isCianPartner?: boolean;
  name: IAgentCard['name'];
  onDescriptionClick(): void;
  ratingSubtitle: string;
  rate: number;
  participations: IAgentCardParticipation[];
  contacts: React.ReactNode;
  badge: React.ReactNode;
}

export const AboutRealtorDesktop = ({
  about,
  avatarUrl,
  counters,
  isAvatarRound,
  isCianPartner,
  name,
  rate,
  ratingSubtitle,
  participations,
  contacts,
  badge,
}: IAboutRealtorDesktopProps) => {
  return (
    <Section className={styles['container']}>
      <div className={styles['row']}>
        <NoSsr>
          <Avatar isRound={isAvatarRound} avatarUrl={avatarUrl} />
        </NoSsr>
        <Name isCianPartner={isCianPartner} name={name} participations={participations} />
      </div>
      <NoSsr>
        <div className={styles['row']}>
          <div className={styles['rating-column']}>
            <Rating text={ratingSubtitle} value={rate} />
            {badge}
          </div>
          {counters.length ? <Counters counters={counters} /> : null}
        </div>
      </NoSsr>
      <div className={styles['description-container']}>
        {about.map(({ label, text, action }) => (
          <DescriptionRow key={label} label={label} text={text} action={action} />
        ))}
      </div>
      {contacts}
    </Section>
  );
};
